<!-- 资料 -->
<template>
	<div class="wrap">

		<div class="header-wrap">
			<div class="header">
				<img src="../assets/return.png" class="return-img" @click="$router.back()">
				<p class="header-title">资料</p>
			</div>
			<div class="search-box">
				<div class="search-bar" @click="$router.push('/search?type=3')">
					<img src="../assets/search-icon.png" class="search-icon">
					<input type="search" ref="searchInput"disabled placeholder="请输入搜索关键字" class="search-input" />
				</div>
				<button v-if="inputing" type="button" class="cancel-btn">取消</button>
			</div>
			<ul class="sub-tab-list">
				<li class="active">推荐</li>
			</ul>
		</div>

    <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="list.length > 0 ? '没有更多了' : ''"
        @load="getList"
    >
      <ul class="list">
        <li v-for="(item, index) in list" :key="index" @click="toDetail(item)">
          <div class="img-box">
            <img :src="item.fileIcon" class="img">
            <img v-if="item.is_vip === 1" src="../assets/icon-25.png" class="tag">
          </div>
          <div class="item-sidebar">
            <div class="item-column">
              <p class="item-name">{{ item.title }}</p>
              <p class="item-msg">{{ item.desc || '　' }}</p>
            </div>
            <p class="row">
              <img src="../assets/icon-17.png" class="icon">
              {{ item.read_num }}
            </p>
          </div>
        </li>
      </ul>
    </van-list>

		<div class="float-box" @click="show = true">
			<img src="../assets/icon-26.png">
		</div>

		<!-- 显示开通vip -->
		<van-overlay :show="showOpenVip" @click="showOpenVip = false" z-index="99999">
			<div class="open-vip">
				<p>仅支持VIP查看</p>
				<p>开通VIP查看本材料</p>
				<button @click="$router.push('/member')">开通VIP会员</button>
			</div>
		</van-overlay>

		<!-- 发布弹窗 -->
		<van-overlay :show="show" z-index="99999">
			<div class="window">
				<div class="window-top">
					<button type="button" class="window-btn" @click.stop="show = false; $router.push('/paid-contribution-video?type=3')">
						<img src="../assets/icon-31.png">有偿上传资料
					</button>
					<button type="button" class="window-btn del" @click.stop="show = false; $router.push('/information-release')">
						<img src="../assets/icon-32.png">无偿上传资料
					</button>
				</div>
				<div class="window-btn-box">
					<button type="button" @click="show = false">
						<img src="../assets/close-icon3.png">
					</button>
				</div>
			</div>
		</van-overlay>

	</div>
</template>

<script>
import {DatumService, UserCenterService} from "@/common/service";
import {Dialog} from "vant";
import {getFileIcon, getFileType} from "@/common/util";

  export default {
		components: {},
		data() {
			return {
				inputing: false,

				// 显示开通vip
				showOpenVip: false,
				
        show: false,
        params: {
          type: 0,  // 类型1单个2系列
          is_tj: 1,  // 是否推荐0否1是
          page: 1,  // 页数
          page_num: 20,  // 每页数
        },
        list: [],
        loading: false,
        finished: false,


        isLogin: false,
        isVip: false,
			};
		},
		mounted() {
      this.getUserInfo();
    },
		methods: {
      getList() {
        this.loading = true;
        DatumService.getDatumList(this.params).then(({ data }) => {
          // 展开集合视频，并合并到列表
          const list = data.list.map(item => {
            if (item.url_arr.length > 1) {
              item['fileType'] = 'folder_bg';
            } else {
              item['fileType'] = getFileType(item.datum_url);
            }
            item['fileIcon'] = getFileIcon(`${item['fileType']}_bg`);
            return item;
          });
          this.list = this.params.page === 1 ? list : [...this.list, ...list];
          if (list.length < this.params.page_num) {
            this.finished = true;
          } else {
            this.params.page++;
          }
        }).finally(() => {
          this.loading = false;
        });
      },
      getUserInfo() {
        UserCenterService.getUserInfo().then(({ data }) => {
          this.isLogin = true;
          const userLevel = data.user_level;
          if (userLevel && userLevel.id > 0) {
            const currentTime = new Date().getTime();
            const endTime = new Date(userLevel.end_date.replace(/-/g, '/')).getTime();
            this.isVip = currentTime < endTime;
          }
        });
      },
      toDetail(item) {
        if (item.url_arr.length > 1) {
          this.$router.push(`/information-series?id=${item.id}`);
        } else {
          if (item.url_arr[0].is_vip === 1) {
            if (!this.isLogin) {
              return Dialog.confirm({
                message: 'VIP资料请登录后查看',
                confirmButtonText: '去登录'
              }).then(() => {
                this.$router.push('/login');
              });
            }
            if (!this.isVip) {
              // return this.showOpenVip = true;
            }
          }
          this.$router.push(`/information-details?id=${item.id}&url_id=${item.url_arr[0].id}`);
        }
      },
		},
    // 清除页面缓存
    beforeRouteLeave(to, from, next) {
      // return next();
      // if (to.path === "/video-details") {
      if (from.meta.toPagesKeep.includes(to.path)) {
        from.meta.keepAlive = true;
      } else {
        let vnode = this.$vnode;
        let parentVnode = vnode && vnode.parent;
        if (parentVnode && parentVnode.componentInstance && parentVnode.componentInstance.cache) {
          var key = vnode.key == null
              ? node.componentOptions.Ctor.cid + (vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : '')
              : vnode.key;
          var cache = parentVnode.componentInstance.cache;
          var keys = parentVnode.componentInstance.keys;
          if (cache[key]) {
            this.$destroy();
            // remove key
            if (keys.length) {
              var index = keys.indexOf(key);
              if (index > -1) {
                keys.splice(index, 1)
              }
            }
            cache[key] = null;
          }
        }
      }
      next();
    },
	}
</script>

<style scoped>
	.wrap {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 144px 15px 0;
		box-sizing: border-box;
	}

	/* 头部样式 */
	.header-wrap {
		width: 100%;
		height: 144px;
		display: flex;
		flex-direction: column;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 500;
		background-color: #FFFFFF;
	}

	.header-wrap-tab-list-none {
		height: 80px;
		padding-bottom: 10px;
	}

	.header {
		width: 100%;
		height: 44px;
		display: flex;
		align-items: center;
		justify-content: center;
		background-color: #FFFFFF;
		z-index: 999;
		padding: 0 15px;
		position: relative;
		box-sizing: border-box;
	}

	.return-img {
		position: absolute;
		left: 15px;
		top: 50%;
		transform: translate(0, -50%);
		width: 20px;
	}

	.header-title {
		color: #333333;
		font-size: 18px;
		font-weight: 500;
	}

	.search-box {
		width: 100%;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.cancel-btn {
		margin-left: 10px;
		font-size: 15px;
		color: #666666;
	}

	.search-bar {
		flex: 1;
		height: 38px;
		background-color: #F3F3F3;
		border-radius: 100px;
		display: flex;
		align-items: center;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.search-icon {
		width: 14px;
		margin-right: 8px;
	}

	.search-input {
		flex: 1;
		font-size: 14px;
	}

	.search-input::placeholder {
		color: #7F7F7F;
	}

	.sub-tab-list {
		width: 100%;
		height: 62px;
		white-space: nowrap;
		padding: 0 15px;
		box-sizing: border-box;
	}

	.sub-tab-list>li {
		display: inline-block;
		height: 48px;
		line-height: 48px;
		font-size: 18px;
		color: #555555;
		position: relative;
	}

	.sub-tab-list>li.active {
		font-weight: 500;
		color: #222222;
	}

	.sub-tab-list>li.active::after {
		content: "";
		width: 18px;
		height: 4px;
		background: linear-gradient(90deg, #2A63F3, #81B8FF);
		border-radius: 2px;
		position: absolute;
		bottom: 0;
		left: 50%;
		transform: translate(-50%, 0);
	}

	.list {
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 10px 0;
	}

	.list>li {
		width: 100%;
		display: flex;
		align-items: center;
		margin-bottom: 16px;
	}

	.img-box {
		width: 60px;
		height: 60px;
		position: relative;
	}

	.img {
		width: 100%;
		height: 100%;
	}

	.tag {
		position: absolute;
		right: 0;
		top: 0;
		width: 20px;
	}

	.item-sidebar {
		flex: 1;
		display: flex;
		align-items: center;
		margin-left: 14px;
	}

	.item-column {
		flex: 1;
		display: flex;
		flex-direction: column;
	}

	.item-name {
		width: 100%;
		color: #222222;
		font-size: 15px;
		font-weight: bold;
		margin-bottom: 5px;
	}

	.item-msg {
		width: 100%;
		color: #999999;
		font-size: 10px;
	}

	.row {
		display: flex;
		flex-direction: column;
		align-items: center;
		color: #666666;
		font-size: 10px;
	}

	.icon {
		width: 14px;
		margin-bottom: 3px;
	}

	.float-box {
		position: fixed;
		bottom: 10%;
		right: 7px;
		z-index: 999;
	}

	.float-box>img {
		width: 62px;
	}

	.open-vip {
		width: 275px;
		height: 170px;
		background: #FFFFFF;
		border-radius: 16px;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin: 273px auto 0;
	}

	.open-vip p {
		font-size: 16px;
		font-weight: 500;
		color: #222222;
		line-height: 35px;
	}

	.open-vip button {
		width: 215px;
		height: 40px;
		background: #EBD793;
		border-radius: 20px;
		font-size: 15px;
		font-weight: 500;
		color: #553D0E;
		margin-top: 10px;
	}
	
	.window {
		width: 100%;
		display: flex;
		flex-direction: column;
		position: fixed;
		bottom: 0;
		left: 0;
		z-index: 99999999;
	}
	
	.window-top {
		width: 100%;
		display: flex;
		flex-direction: column;
	}
	
	.window-btn {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
		font-weight: 500;
		font-size: 16px;
		margin-bottom: 40px;
	}
	
	.window-btn>img {
		width: 60px;
		margin-right: 10px;
	}
	
	.window-btn-box {
		width: 100%;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 40px 0;
		box-sizing: border-box;
	}
	
	.window-btn-box>button {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	
	.window-btn-box>button>img {
		width: 40px;
	}
</style>
